import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [session, setSession] = useState(null);
  const [sound, setSound] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const [s, g] = await Promise.all([api.get("/public/site"), api.get("/gate/session")]);
      setSite(s.data || null);
      setSession(g.data || { active: false });
    } catch (e) {
      setSite((x) => x || { slogan: "Every leaf or every branches makes a great tree", footer_text: "\u00a9 2006 MARAIS FAMILY. All rights reserved.", eras: {}, timeline: [] });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await api.post("/gate/logout"); } catch (e) { /* ignore */ }
    await refresh();
  };

  return <Ctx.Provider value={{ site, session, refresh, logout, sound, setSound }}>{children}</Ctx.Provider>;
};

export const useSite = () => useContext(Ctx);
